module.exports = __webpack_public_path__ + "img/semipublic.26b7a546.svg";